import { GET_SNAPSHOTS_LIST, GET_SNAPSHOTS_LIST_SILENT, RESET_SNAPSHOTS_LIST } from "../../actionTypes/actionsTypes";
import { AppAction, AppNoApiAction, BaseAsyncReducerState } from "../../types";

export interface Snapshot {
    roll: string,
    type: "POI" | "SNAPSHOT" | "MY PROPERTY",
    centroid: SnapshotCentroid | null;
    reported: string,
    details: PoiDetails | undefined;
}

export interface SnapshotCentroid {
    lat: number;
    lng: number;
}

export interface PoiDetails {
    addr: string,
    cva: string,
    sales: PoiDetailSales | null | "",
    myRoll: true
}

export interface PoiDetailSales {
    sale_amt: "string";
    sale_dte: "string"
}

export interface SnapshotListResponse {
    roll: string;
    count: number;
    snapshots: Snapshot[]
}

export interface getSnapshotsListState extends BaseAsyncReducerState {
    poiListDetail?: SnapshotListResponse;
}
// Define an initial state value for the app
const initialState: getSnapshotsListState  = {
    loading: false,
    error: false
}


function getSnapshotsListReducer(state = initialState, action: AppAction | AppNoApiAction) {
    // Reducers usually look at the type of action that happened
    // to decide how to update the state

    const { payload } = action;

    switch (action.type) {
        case GET_SNAPSHOTS_LIST.PENDING:
            return {
                ...state,
                loading: true,
                error: false
            }
        case GET_SNAPSHOTS_LIST.SUCCESS:
        case GET_SNAPSHOTS_LIST_SILENT.SUCCESS:
            return {
                ...state,
                poiListDetail: payload,
                loading: false,
                error: false

            }
        case GET_SNAPSHOTS_LIST.ERROR:
            return {
                ...state,
                loading: false,
                error: payload
            };
        case RESET_SNAPSHOTS_LIST:
            return {
                ...state,
                poiListDetail: null
            }
        default:
            return state
        }
}

export default getSnapshotsListReducer;